import { getLang } from './localStorageUtils';

export const truncateString = (str: string, maxLength: number): string => {
  if (!str) return '';

  if (str.length <= maxLength) {
    return str;
  }

  const isRTL = getLang() === 'ar';
  const slice = str.substring(0, maxLength);

  return isRTL ? `...${slice}` : `${slice}...`;
};
